import { B2B_STATION_CHARGING_HISTORY } from 'actions/dataReport';

const initialState = {
  isLoading: false,
  b2bStationChargingHistory: [],
  page: 1,
  limit: 10,
  totalPages: 1,
  total: 1,
};

const b2bStationChargingHistoryReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case B2B_STATION_CHARGING_HISTORY.REQUEST: {
      return { ...state, isLoading: true };
    }
    case B2B_STATION_CHARGING_HISTORY.SUCCESS: {
      return {
        ...state,
        isLoading: false,
        b2bStationChargingHistory: payload.results,
        page: payload.page,
        limit: payload.limit,
        totalPages: payload.totalPages,
        total: payload.totalResults,
      };
    }

    case B2B_STATION_CHARGING_HISTORY.FAIL: {
      return { ...state, isLoading: false };
    }
    default:
      return { ...state };
  }
};
export default b2bStationChargingHistoryReducer;
